export const DIALOG_OPEN = "DIALOG_OPEN";

/**
 * Tell's if in the application there is an opened dialog
 */
export const openDialog = (isDialogOpen: boolean) => ({
  type: DIALOG_OPEN,
  payload: isDialogOpen
});